import React, { useEffect, useState } from "react";
import axios from "axios";
import { Wallet, Download, Smartphone } from "lucide-react";
import { GiftCardVisual } from "../GiftCardVisual";
import { GIFT_THEMES, GIFT_POINTS, BRAND } from "./landingData";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Sezione Gift Card della landing: grafiche di esempio predefinite, sostituite da quelle del circuito «vetrina» scelto dal Super-Admin (se ha immagini)
export function LandingGiftCards() {
  const [themes, setThemes] = useState(GIFT_THEMES);
  const [active, setActive] = useState(GIFT_THEMES[0]);
  useEffect(() => {
    axios.get(`${API}/platform/public/landing/gift-themes`).then(({ data }) => {
      const live = (data?.themes || []).filter((t) => t.image_url);
      if (!live.length) return;
      const merged = live.map((t, i) => ({ ...(GIFT_THEMES.find((g) => g.id === t.id) || GIFT_THEMES[i % GIFT_THEMES.length]), ...t }));
      setThemes(merged); setActive(merged[0]);
    }).catch(() => {});
  }, []);
  return (
    <section id="gift-card" className="bg-slate-50 scroll-mt-20" data-testid="landing-gift-cards">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-16 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-start">
          <div className="lg:col-span-5">
            <span className="inline-block text-[11px] font-bold uppercase tracking-widest text-rose-700 bg-rose-50 ring-1 ring-rose-200 rounded-full px-3 py-1">Gift Card</span>
            <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight text-slate-900 mt-4" data-testid="gift-title">Carte regalo del tuo circuito, vendute online</h2>
            <p className="text-base md:text-lg text-slate-600 mt-3">Un nuovo incasso anticipato e nuovi clienti che entrano in negozio con un buono già pagato. Chi regala sceglie importo, grafica e messaggio; chi riceve la salva nel Wallet e spende quando vuole.</p>
            <ul className="mt-8 space-y-5">
              {GIFT_POINTS.map((p) => (
                <li key={p.id} className="flex gap-4" data-testid={`gift-point-${p.id}`}>
                  <div className="h-10 w-10 shrink-0 rounded-xl bg-white ring-1 ring-slate-200 shadow-sm flex items-center justify-center"><p.icon className="h-5 w-5" style={{ color: BRAND }} /></div>
                  <div><div className="font-heading font-bold text-slate-900">{p.title}</div><p className="text-sm text-slate-600 mt-1 leading-relaxed">{p.desc}</p></div>
                </li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-7 lg:sticky lg:top-24">
            <div className="max-w-md mx-auto lg:max-w-none lg:ml-auto lg:mr-0 lg:w-[92%]" data-testid="gift-preview">
              <GiftCardVisual theme={active} amount={active.amount || 50} code="GC-7K2M-9QXA" recipient_name={active.recipient || "Giulia"} sender_name={active.sender || "Marco"} app_name="Il tuo circuito" testid="gift-preview-card" />
              <div className="flex flex-wrap gap-2 mt-4 justify-end" data-testid="gift-preview-actions">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-black text-white px-3 h-9 text-xs font-semibold"><Wallet className="h-3.5 w-3.5" /> Apple Wallet</span>
                <span className="inline-flex items-center gap-1.5 rounded-full bg-slate-800 text-white px-3 h-9 text-xs font-semibold"><Smartphone className="h-3.5 w-3.5" /> Google Wallet</span>
                <span className="inline-flex items-center gap-1.5 rounded-full bg-white ring-1 ring-slate-300 text-slate-800 px-3 h-9 text-xs font-semibold"><Download className="h-3.5 w-3.5" /> Immagine</span>
              </div>
            </div>
            <p className="text-xs uppercase tracking-widest text-slate-500 font-bold mt-8 mb-3">{themes.length} grafiche a tema, pronte all'uso e personalizzabili con le tue foto</p>
            <div className="grid grid-cols-3 sm:grid-cols-6 gap-3" data-testid="gift-themes">
              {themes.map((t, i) => (
                <button key={t.id} type="button" onClick={() => setActive(t)} aria-pressed={active.id === t.id}
                  className={`group rounded-2xl p-1.5 bg-white ring-1 transition-[box-shadow,transform,ring-color] hover:-translate-y-0.5 hover:shadow-md animate-fade-up ${active.id === t.id ? "ring-2 ring-slate-900 shadow-md" : "ring-slate-200"}`}
                  style={{ animationDelay: `${i * 50}ms` }} data-testid={`gift-theme-${t.id}`}>
                  <GiftCardVisual theme={t} thumb testid={`gift-theme-visual-${t.id}`} />
                  <div className="text-[11px] font-semibold text-slate-700 mt-1.5 text-center truncate">{t.label}</div>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
